import { ifAuthenticated, ifNotAuthenticated } from "@/router";

export default [
  {
    path: "/users",
    name: "usersIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/user/Index.vue")
  },
  {
    path: "/users/:userId/edit",
    name: "usersEdit",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "user" */ "@/views/user/Edit.vue")
  },
  {
    path: "/users/register/:token",
    name: "usersRegistration",
    beforeEnter: ifNotAuthenticated,
    component: () =>
      import(/* webpackChunkName: "register" */ "@/views/user/Register.vue")
  }
];
